import axios from "axios";
import data from "./dataset"

export default {
    namespaced: true, state: {
        error: null, blocks: null, loading: true,
    }, getters: {
        error(state) {
            return state.error
        }, blocks(state) {
            return state.blocks
        }, content: (state) => (id) => {
            return state.blocks.filter(block => block.id === id)[0]
        }, loading(state) {
            return state.loading
        }
    }, mutations: {
        'set_error': (state, payload) => {
            state.error = payload
        }, 'set_blocks': (state, payload) => {
            state.blocks = payload
        }, 'loading': (state, payload) => {
            state.loading = payload
        }
    }, actions: {
        init({commit}) {
            commit('loading', true)
            commit('set_blocks', data)
            commit('loading', false)
        }, async sendMail({}, payload) {
            let tok = await axios.post('https://api.postman.artatol.net/login_check', {
                'username': process.env.VUE_APP_ALL_TOKEN_USERNAME, 'password': process.env.VUE_APP_ALL_TOKEN_PASSWORD
            }, {
                headers: {
                    'Accept': 'application/json'
                }
            })
            let res = await axios.post('https://api.postman.artatol.net/mails', {
                'templateId': 2,
                'category': 'dezinfekce-potrubi',
                'mailFrom': 'info@artatol.com',
                'mailFromName': 'Dezinfekce potrubí - web form',
                "mailTo": "dezinfekce@dezinfekcepotrubi.cz",
                "subject": 'Dotaz z webu dezinfekce potrubi',
                "context": {
                    'favicon': '',
                    'align': 'left',
                    'headline': "Dotaz z webu",
                    'body_html': "<h4>Od: " + payload.name + "</h4><h4>Kontakt: " + payload.contact + "</h4>Zpráva:<p>" + payload.message + "</p>",
                    'body_p_style': 'font-size: 1.05em !important; line-height:1.1em !important; martin-top: 0px; margin-bottom:15px;',
                    'copy_html': '&copy; dezinfekcepotrubi.cz'
                }
            }, {
                headers: {
                    'Authorization': 'Bearer ' + tok.data.token, 'Accept': 'application/json'
                }
            })
            if (res.status == 201) {
                return "ok"
            }
        }
    }
}
